document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-section .scroll-to-top').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });
});